// components/account/index
// меню клиента

import Store    from 'Store'
import router   from 'router'

import template from './template.jade'
import style    from './style.scss'

var name = 'account'
var store = new Store(name)

var links = [
  { name: 'profile',  text: 'Профиль'   },
  { name: 'settings', text: 'Настройки' },
  { name: 'logout',   text: 'Выход'     },
]

export default {

  el: '.sign_in',
  name: name,
  template: template({style: style}),
  replace: false,

  data: () => ({
    store: store.data,
    image: '/assets/i/svg/Kabinet_red.svg',
    links: links,
  }),

  methods: {
    onClick(e) {
      // если есть роутер app, то переходим по ссылке
      // с помощью роутера
      if (router.app) {
        e.preventDefault()
        var name = e.target.dataset.name
        router.go({name: name})
      }
    },
  },

  computed: {
    image() {
      var image = 'http://www.gravatar.com/avatar/'
      var hash = this.$get('store.gravator_hash')
      return hash ? image + hash + "?s=40" : "/assets/i/svg/Kabinet_red.svg"
    }
  },

}



/** WEBPACK FOOTER **
 ** ./src/js/components/menu-account/index.js
 **/